import { FC } from 'react';
import { Heading, Types, Accordion } from '@marriott/mi-ui-library';
import { EventTrackingData, EventTrackingProps } from './EventTracking.types';
import { StyledEventTracking } from './EventTracking.styles';
import { PickupStatsCard } from '../../../../molecules/PickupStatsCard';
import { PropertyPrimaryImage } from '@marriott/mi-groups-graphql';
import { useDttStore, useLocaleStore } from '../../../../../store';
import { getAlertCountForSubscription } from '../../../../utils/reslink';
import { EventBookingDetails } from '../../../rooming-list/PlannerNewEvent/EventBookingDetails';
import { DEFAULT_LANG } from '../../../../../constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EventTracking: FC<EventTrackingProps> = (props: any) => {
  const {
    pickupStatsCardLabels,
    heading,
    bookingStatsLabels,
    groupRatesLabels,
    eventTrackingData,
    alertSubscriptionsByKey = {},
    viewAlerts,
  } = props;

  const { isPickupStatsAlertsEnabled } = useDttStore();
  const { locale } = useLocaleStore();

  const showPickupStatsCards = locale?.toLowerCase() === DEFAULT_LANG.toLowerCase();

  return eventTrackingData?.length > 0 ? (
    <StyledEventTracking data-testid="groups-EventTracking" data-component-name="o-groups-EventTracking">
      <div className="m-0 row align-items-center justify-content-between">
        <Heading
          variation={Types.headingType.subtitle}
          element={Types.tags.h1}
          titleText={heading}
          fontSize={Types.size.extraLarge}
          customClass="my-5"
        />
      </div>
      {showPickupStatsCards ? (
        <div className="row">
          {eventTrackingData.map((eventDetails: EventTrackingData) => {
            const availabilityList = eventDetails?.bookingStatsData?.availabilityList ?? [];
            const startDate = availabilityList?.[0]?.startDate ?? '';
            const endDate = availabilityList?.[availabilityList.length - 1]?.startDate ?? '';
            const showAlertCta =
              !eventDetails?.isNewlyAdded && (!isPickupStatsAlertsEnabled || !!eventDetails?.isPickupAlertEligible);
            const subscription = eventDetails?.pickupAlertIdentityKey
              ? alertSubscriptionsByKey[eventDetails.pickupAlertIdentityKey]
              : undefined;
            const alertCount = getAlertCountForSubscription(subscription);

            return (
              eventDetails && (
                <div key={`pickup-card-${eventDetails?.propertyIndex}`} className="col-sm-12 col-md-6 col-lg-4 mb-4">
                  <PickupStatsCard
                    cardLabels={pickupStatsCardLabels}
                    cardData={{
                      media: eventDetails?.media as PropertyPrimaryImage,
                      propertyName: eventDetails?.propertyName,
                      alertCount,
                      date: { startDate, endDate },
                      rooms: {
                        totalPickups: eventDetails?.bookingStatsData?.totalSold || 0,
                        totalContracted: eventDetails?.bookingStatsData?.totalRooms || 0,
                      },
                    }}
                    disableAlerts={!isPickupStatsAlertsEnabled}
                    showAlertCta={showAlertCta}
                    isNewlyAdded={eventDetails?.isNewlyAdded}
                    onClick={() => viewAlerts?.(eventDetails?.propertyIndex)}
                  />
                </div>
              )
            );
          })}
        </div>
      ) : (
        <div>
          {eventTrackingData.map(
            (eventDetails: EventTrackingData) =>
              eventDetails && (
                <Accordion
                  key={`accordion-${eventDetails?.propertyIndex}`}
                  id={`accordion-${eventDetails?.propertyIndex}`}
                  headerChildren={eventDetails?.propertyName}
                >
                  <EventBookingDetails
                    bookingStatsLabels={bookingStatsLabels}
                    bookingStatsData={eventDetails?.bookingStatsData}
                    groupRatesLabels={groupRatesLabels}
                    groupRatesData={eventDetails?.groupRatesData}
                  />
                </Accordion>
              )
          )}
        </div>
      )}
    </StyledEventTracking>
  ) : null;
};
